function LoginButton() {
  return (
    <div className="flex mt-2 justify-center text-white bg-black w-[300px] h-[55px]">
      <p className="font-poppins mt-3">Continue</p>
    </div>
  );
}

export default LoginButton;
